import IndexDialog from 'src/components/dialog/index.vue'
import { reOrder } from 'src/api/order.js';
import { dialogQueue } from 'src/components/dialog';

export const PAY_STATUS = {
  SUCCESS: 'SUCCESS',
  PENDING: 'PENDING',
  FAILED: 'FAILED'
}

export function paySuccess(vm, orderDetail) {
  const { orderId } = orderDetail || {};
  if (orderDetail?.serviceType === 'FULL_DINE_IN') {
    vm.$router.push({ name: 'FullPaySuccess', query: { orderId } });
  } else {
    vm.$router.push({ name: 'success', query: { orderId } });
  }
}

export function backToCheckout(vm) {
  const name = vm.isFullDineIn ? 'FullCheckout' : 'checkout';
  const { orderId, order_id: oid } = vm.$route.query;
  reOrder({ orderId: orderId || oid }).then(() => {
    vm.$router.replace({ name, query: { orderId: orderId || oid } })
  })
}
export function backToPLP(vm) {
  const { orderId, order_id: oid } = vm.$route.query;
  reOrder({ orderId: orderId || oid }).then(() => {
    vm.$router.replace({ name: 'products-list' })
  })
}

export const getPayFailedConfig = (vm, reason) => {
  // 只有已登录才允许跳转到结账页面
  const checkoutConfig = vm.logged ? {
    ok: vm.$t('waiting.okBtn'),
    callback: backToCheckout,
  } : {}
  const PAY_FAILED_REASON = {
    PAYMENT_TIMEOUT: {
      customIcon: 'https://static.bakmigm.co.id/menu/dialog-icon/dialog_warn_icon.svg',
      title: vm.$t('waiting.payQrisTimeout'),
      describe: vm.$t('waiting.timeoutDes'),
      cancel: vm.$t('waiting.backList'),
      onCancel: backToPLP,
      ...checkoutConfig
    },
    DENY_BY_THIRD_PARTY: {
      customIcon: 'https://static.bakmigm.co.id/menu/dialog-icon/dialog_warn_icon.svg',
      title: vm.$t('waiting.payQrisDeny'),
      cancel: vm.$t('waiting.backList'),
      onCancel: backToPLP,
      ...checkoutConfig
    },
    THIRD_PARTY_ERROR: {
      customIcon: 'https://static.bakmigm.co.id/menu/dialog-icon/dialog_warn_icon.svg',
      title: vm.$t('waiting.payQrisError'),
      cancel: vm.$t('waiting.backList'),
      onCancel: backToPLP,
      ...checkoutConfig
    },
    PAY_TIME_TIP: {
      customIcon: 'https://static.bakmigm.co.id/menu/dialog-icon/dialog_warn_icon.svg',
      title: vm.$t('waiting.timetipTitle'),
      describe: vm.$t('waiting.timetipDes'),
      ok: vm.$t('common.ok'),
    },
    PENDING: {
      customIcon: 'https://static.bakmigm.co.id/menu/dialog-icon/dialog_warn_icon.svg',
      title: vm.$t('waiting.payQrisPedding'),
      describe: vm.$t('waiting.timeoutDes'),
      ok: vm.$t('checkout.continue'),
      callback() { }
    },
    DEFAULT: {
      component: IndexDialog,
      cancel: vm.$t('waiting.backList'),
      title: vm.$t('waiting.paymentRejectedTitle'),
      onCancel: backToPLP,
      ...checkoutConfig
    }
  }
  return PAY_FAILED_REASON[reason] || PAY_FAILED_REASON.DEFAULT;
}

export function showPayFailedDialog(vm, reason, props = {}) {
  console.log(vm, reason, '====')
  const config = getPayFailedConfig(vm, reason);
  const { customIcon, ...others } = props;
  const dialog = vm.$q.dialog({
    component: IndexDialog,
    parent: vm,
    title: config.title,
    describe: config.describe,
    ok: config.ok,
    cancel: config.cancel,
    customIcon: customIcon || config.customIcon,
    ...others
  }).onOk(() => {
    config.callback?.(vm);
  }).onCancel(() => {
    config.onCancel?.(vm);
  })
  dialogQueue.push(dialog);
  return dialog;
}
